<template>
  <!-- Top Menu Bar (Figma 상단 메뉴바) -->
  <TopMenuBar />

  <!-- Main Layout -->
  <div id="main-layout" class="d-flex flex-fill flex-row align-items-stretch default-layout">
    <!-- Logo (좌측 상단) -->

    <!-- Left LNB (Figma 좌측 LNB) -->
    <div id="left-lnb" class="left-navigation" :class="{ collapsed: isLnbCollapsed }">
      <LeftLNB />
    </div>

    <!-- Main Content Area -->
    <div id="main-content" class="main-content-area" :class="{ expanded: isLnbCollapsed }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useStore } from "@/store";
  import TopMenuBar from "@/components/layout/TopMenuBar.vue";
  import LeftLNB from "@/components/layout/LeftLNB.vue";

  const store = useStore();

  // LNB 접기/펼치기 상태 확인 (안전장치 추가)
  const isLnbCollapsed = computed(() => {
    try {
      return store?.getters?.isLnbCollapsed || false;
    } catch (error) {
      console.warn("Store getters 접근 실패, 기본값 사용:", error);
      return false;
    }
  });
</script>
<style lang="scss">
  @use "@/assets/styles/layout" as *;
  @use "@/assets/styles/admin" as *;
  @use "@/assets/styles/grid-table" as *;

  /* New Figma layout styles (moved to layout.scss) */
  #main-layout {
    margin-top: 0; /* 상단 여백 완전 제거 */
    min-height: 100vh;
    padding: 0 16px;
    position: relative; /* 로고 absolute positioning을 위한 기준점 */
  }

  /* Main Layout Logo (좌측 상단) */
  .main-layout-logo {
    position: fixed; /* 화면에 고정 */
    top: -60px !important; /* 화면 최상단에 강제로 붙이기 */
    left: 16px;
    z-index: 1001 !important; /* TopMenuBar(1000)보다 높게 설정하여 레프트 메뉴바 위에 표시 */
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1;
    pointer-events: none; /* 클릭 이벤트 통과 - 레프트 메뉴바 클릭 가능하도록 */

    img {
      display: block;
      height: auto;
      max-width: 300px; /* 로고 크기 */
      width: auto;
      margin: 0;
      padding: 0;
      pointer-events: none; /* 이미지도 클릭 이벤트 통과 */
    }
  }

  .left-navigation {
    width: 300px;
    min-width: 300px;
    height: calc(100vh - 128px);
    margin-right: 16px;
    flex-shrink: 0;
    margin-top: 0; /* 상단 여백 제거 */
    transition: all 0.3s ease; /* 부드러운 전환 효과 */
    // position: relative;
    z-index: 10; /* 로고보다 낮은 z-index */
    margin-left: 0; /* 로고와 겹치지 않도록 */

    &.collapsed {
      width: 80px;
      min-width: 80px;
      margin-right: 8px;
    }
  }

  .main-content-area {
    flex: 1;
    background: #f2f2f2;
    border-radius: 32px;
    height: calc(100vh - 128px); /* min-height를 height로 변경하여 정확한 높이 설정 */
    overflow-y: auto;
    margin-top: 0; /* 상단 여백 제거 */
    transition: all 0.3s ease; /* 부드러운 전환 효과 */

    &.expanded {
      margin-left: 0; /* LNB가 접힌 상태일 때 왼쪽 여백 제거 */
      /* LNB가 접힌 상태일 때 더 넓은 공간 확보 */
      width: calc(100% + 220px); /* 300px - 80px = 220px만큼 추가 너비 */
    }
  }

</style>
